import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import {
  Nav,
  NavbarBrand,
  Row,
  Collapse,
} from 'reactstrap'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { get, set, find } from 'lodash'
import styled from 'styled-components'
import shortid from 'shortid'
import leftArrow from '../../static/images/left-arrow.svg'
import dropdownArrow from '../../static/images/dropdown-arrow.svg'
import ActiveStar from '../../static/images/star.svg'
import NormalStar from '../../static/images/star-1.svg'
import "../../static/css/index.css"
import {
  employeeAction,
  authAction,
  sidebarAction,
} from './../../actions/'
import {
  employeeSelector,
  authSelector,
  sidebarSelector,
} from './../../selectors'
import { FONTS } from '../../constants'

import * as pps_report from '../../pages/report/project-profit-sheet'
import * as billingplan_report from '../../pages/report/billing-plan'
import * as summarytimesheet_report from '../../pages/report/summary-timesheet'

const hlogo = require(`../../static/images/kawari-logo-${process.env.REACT_APP_LOGO}.svg`)

// ? track how many menus are currently on the sidebar
const MENU_COUNT = 35

class Sidebar extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'authData.user.favorite_menu') !== prevState.favoriteMenu) {
      const stars = []
      for (let i = 0; i < MENU_COUNT + 1; i++) stars.push(NormalStar)
      if (get(nextProps, 'authData.user.favorite_menu') !== undefined) {
        get(nextProps, 'authData.user.favorite_menu').map(fav => {
          stars[fav] = ActiveStar
          return fav
        })
      }
      set(tempState, 'iconUrl', stars)
      set(tempState, 'favoriteMenu', get(nextProps, 'authData.user.favorite_menu'))
    }
    if (get(nextProps, 'collapseSidebarData') !== prevState.collapse) {
      const arrow = []
      const temp = get(nextProps, 'collapseSidebarData')
      for (let i = 0; i < temp.length; i++) {
        if (temp[i]) arrow.push(dropdownArrow)
        else arrow.push(leftArrow)
      }
      set(tempState, 'collapse', temp)
      set(tempState, 'arrowUrl', arrow)
    }
    if (get(nextProps, 'favoriteMenu')) {
      const access_token = localStorage.getItem('access_token')
      nextProps.resetEditFavoriteMenu()
      nextProps.getAuth(access_token)
    }
    return tempState
  }

  constructor(props) {
    super(props)
    this.state = {
      favoriteMenu: [],
      iconUrl: [],
      arrowUrl: [leftArrow, leftArrow, leftArrow, leftArrow, leftArrow, leftArrow],
      collapse: [false, false, false, false, false, false],
    }
  }

  componentDidMount() {
    if (localStorage.getItem('sidebarState') !== null) {
      let sidebarIndex = localStorage.getItem('sidebarState')
      const collapseState = this.state.collapse
      sidebarIndex = parseInt(sidebarIndex, 10)
      collapseState.splice(sidebarIndex, 1, true)
      this.props.setCollapseSidebar(collapseState)
      localStorage.removeItem('sidebarState')
    }
  }

  setStar(favoriteMenu) {
    const stars = []
    for (let i = 0; i < MENU_COUNT + 1; i++) stars.push(NormalStar)
    if (favoriteMenu !== undefined) {
      favoriteMenu.map(fav => {
        stars[fav] = ActiveStar
        return fav
      })
    }
    return stars
  }

  getFavoriteList(favoriteMenu, menus) {
    const list = []
    if (favoriteMenu) {
      favoriteMenu.sort().forEach(fav => {
        Object.keys(menus).forEach(m => {
          const item = find(menus[m], {
            no: fav,
          })
          if (item) list.push(item)
        })
      })
    }
    return list
  }

  toggleStar = (index) => {
    const id = get(this.props, 'authData.user._id')
    const access_token = localStorage.getItem('access_token')
    const favoriteMenu = get(this.props, 'authData.user.favorite_menu')
    const idx = favoriteMenu.findIndex((element) => {
      return element === index
    })
    let payload
    if (idx >= 0) {
      const fav = []
      favoriteMenu.forEach((f, key) => {
        if (key !== idx) fav.push(f)
      })
      payload = { favorite_menu: fav }
    } else {
      payload = { favorite_menu: [...favoriteMenu, index] }
    }
    this.props.editFavoriteMenu(id, payload, access_token)
  }

  toggleArrow = (index) => {
    const arrowArr = this.state.arrowUrl.slice()
    const newCollapse = this.state.collapse
    newCollapse[index] = !this.state.collapse[index]
    this.props.setCollapseSidebar(newCollapse)
    if (newCollapse[index]) {
      arrowArr[index] = dropdownArrow
    } else {
      arrowArr[index] = leftArrow
    }
    this.setState({ arrowUrl: arrowArr })
  }

  handleSidebar = (index, path) => {
    if (path === window.location.pathname) {
      localStorage.setItem('sidebarState', index)
      window.location.reload()
    }
    const arrowArr = this.state.arrowUrl.slice()
    const newCollapse = this.state.collapse
    for (let i = 0; i < newCollapse.length; i++) {
      if (i !== index) newCollapse[i] = false
    }
    if (newCollapse[index]) {
      arrowArr[index] = dropdownArrow
    } else {
      arrowArr[index] = leftArrow
    }
    this.props.setCollapseSidebar(newCollapse)
  }

  render() {
    const IsAdminUser = get(this.props, 'authData.user.is_hr_admin_role')
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsHRConfidentialUser = get(this.props, 'authData.user.is_hr_admin_confidential_role')
    const IsHRSubconUser = get(this.props, 'authData.user.is_hr_subcontract_role')
    const IsLOBLeadUser = get(this.props, 'authData.user.is_lob_lead_role')
    const IsPMUser = get(this.props, 'authData.user.is_pm_role')
    const IsManagementUser = get(this.props, 'authData.user.is_management_role')
    const IsSubcontractUser = get(this.props, 'authData.user.is_subcontract_role')
    const IsAccountantUser = get(this.props, 'authData.user.is_accountant_role')
    const IsSalesUser = get(this.props, 'authData.user.is_salesman_role')
    const IsSubmitEfficiencyUser = get(this.props, 'authData.user.is_submit_efficiency_role')
    const IsProjectApproverUser = get(this.props, 'authData.user.is_project_approver_role')
    const IsVPUser = get(this.props, 'authData.user.is_vp_avp_role')
    const IsDisplayPPSUser = get(this.props, 'authData.user.is_display_pps_role')
    // const IsProjectAcknowledgeUser = get(this.props, 'authData.user.is_project_acknowledge_role')

    const adminConditions = (IsHRConfidentialUser
      || IsSystemUser
      || IsAdminUser
      || IsManagementUser
      || IsSalesUser
      || IsAccountantUser
      || IsHRSubconUser)
    const reportConditions = (IsSystemUser
      || IsLOBLeadUser
      || IsHRConfidentialUser
      || IsAdminUser
      || IsManagementUser
      || IsPMUser
      || IsAccountantUser
      || IsDisplayPPSUser)

    const menus = {
      activities: [
        {
          no: 0,
          path: '/my_leave',
          header: 'My Leave',
          conditions: !IsSubcontractUser,
          onMobile: true,
        },
        {
          no: 1,
          path: '/team_calendar',
          header: 'Team Calendar',
          conditions: (IsLOBLeadUser || IsSystemUser || IsHRConfidentialUser || IsManagementUser),
        },
        // {
        //   no: 31,
        //   path: '/new_team_calendar',
        //   header: 'New Team Calendar',
        //   conditions: (IsLOBLeadUser || IsSystemUser || IsHRConfidentialUser || IsManagementUser),
        // },
        {
          no: 2,
          path: '/time_sheet',
          header: 'Timesheet',
          conditions: true,
          onMobile: true,
        },
        {
          no: 3,
          path: '/project_information',
          header: 'Project Information',
          conditions: (IsPMUser
            || IsLOBLeadUser
            || IsAdminUser
            || IsHRConfidentialUser
            || IsManagementUser
            || IsSystemUser
            || IsProjectApproverUser
            || IsAccountantUser
            || IsSalesUser),
        },
        {
          no: 30,
          path: '/project_profit_sheet/overview',
          header: 'Project Profit Sheet',
          conditions:
               IsSystemUser
            || IsManagementUser
            || IsVPUser
            || IsPMUser
            || IsLOBLeadUser
            || IsAccountantUser
            || IsDisplayPPSUser,
        },
        {
          no: 29,
          path: '/efficiency_resource',
          header: 'Efficiency Resource',
          conditions: (IsSystemUser || IsManagementUser || IsLOBLeadUser
            || IsAdminUser || IsHRConfidentialUser || IsAccountantUser || IsSubmitEfficiencyUser),
        },
      ],
      admin: [
        {
          no: 33,
          path: '/accounting_dashboard',
          header: 'Accounting Dashboard',
          conditions: (IsSystemUser || IsAccountantUser || IsManagementUser),
        },
        {
          no: 4,
          path: '/user',
          header: 'Employee Master',
          conditions: (IsHRConfidentialUser || IsSystemUser || IsAdminUser || IsManagementUser),
        },
        {
          no: 5,
          path: '/confidential',
          header: 'Employee Confidential',
          conditions: (IsHRConfidentialUser || IsSystemUser),
        },
        {
          no: 6,
          path: '/standard_price',
          header: 'Actual Cost & Price',
          conditions: (IsHRConfidentialUser || IsSystemUser),
        },
        {
          no: 7,
          path: '/employee_level',
          header: 'Pay Grade Master',
          conditions: (IsHRConfidentialUser || IsSystemUser),
        },
        {
          no: 28,
          path: '/standard_cost_price',
          header: 'Standard Cost & Price',
          conditions: IsSystemUser || IsHRConfidentialUser,
        },
        {
          no: 27,
          path: '/subcontract_rate',
          header: 'Subcontractor Rate',
          conditions: IsSystemUser || IsHRSubconUser,
        },
        {
          no: 8,
          path: '/leave_entitlement',
          header: 'Leave Entitlement Master',
          conditions: (IsHRConfidentialUser || IsSystemUser || IsAdminUser || IsManagementUser),
        },
        {
          no: 9,
          path: '/leave_generation',
          header: 'Leave Entitlement Generation',
          conditions: (IsHRConfidentialUser || IsSystemUser || IsAdminUser || IsManagementUser),
        },
        {
          no: 10,
          path: '/leave_type',
          header: 'Leave Type Master',
          conditions: (IsHRConfidentialUser || IsSystemUser || IsAdminUser || IsManagementUser),
        },
        {
          no: 11,
          path: '/public_holiday',
          header: 'Holiday Master',
          conditions: (IsHRConfidentialUser || IsSystemUser || IsAdminUser || IsManagementUser),
        },
        {
          no: 12,
          path: '/company',
          header: 'Company Master',
          conditions: (IsHRConfidentialUser || IsSystemUser || IsAdminUser || IsManagementUser),
        },
        {
          no: 13,
          path: '/lob',
          header: 'LOB Master',
          conditions: (IsHRConfidentialUser || IsSystemUser || IsAdminUser || IsManagementUser),
        },
        {
          no: 14,
          path: '/department',
          header: 'Department Master',
          conditions: (IsHRConfidentialUser || IsSystemUser || IsAdminUser || IsManagementUser),
        },
        {
          no: 15,
          path: '/position',
          header: 'Position Master',
          conditions: (IsHRConfidentialUser || IsSystemUser || IsAdminUser || IsManagementUser),
        },
        {
          no: 16,
          path: '/division',
          header: 'Division Master',
          conditions: (IsHRConfidentialUser || IsSystemUser || IsAdminUser || IsManagementUser),
        },
        {
          no: 17,
          path: '/team',
          header: 'Team Master',
          conditions: (IsHRConfidentialUser || IsSystemUser || IsAdminUser || IsManagementUser),
        },
        {
          no: 22,
          path: '/client',
          header: 'Client Master',
          conditions: (IsHRConfidentialUser
            || IsAdminUser
            || IsSystemUser
            || IsManagementUser
            || IsSalesUser
            || IsAccountantUser),
        },
        {
          no: 23,
          path: '/project_code',
          header: 'Project Code Master',
          conditions: (IsSystemUser || IsManagementUser || IsAccountantUser),
        },
        {
          no: 32,
          path: '/sale_product',
          header: 'Sale Product Master',
          conditions: (IsSystemUser || IsSalesUser),
        },
        {
          no: 34,
          path: '/consent-management',
          header: 'Consent Management',
          conditions: (IsSystemUser || IsAdminUser || IsHRConfidentialUser),
        },
      ],
      report: [
        {
          no: 18,
          path: '/audit_log',
          header: 'Active Users & Audit Log',
          conditions: (IsSystemUser
            || IsLOBLeadUser
            || IsHRConfidentialUser
            || IsAdminUser
            || IsManagementUser),
        },
        {
          no: 19,
          path: '/leave_history',
          header: 'Leave History',
          conditions: (IsSystemUser
            || IsLOBLeadUser
            || IsHRConfidentialUser
            || IsAdminUser
            || IsManagementUser
            || IsPMUser),
        },
        {
          no: 20,
          path: '/headcount_report',
          header: 'Headcount',
          conditions: (IsSystemUser
            || IsLOBLeadUser
            || IsHRConfidentialUser
            || IsAdminUser
            || IsManagementUser),
        },
        {
          no: 21,
          path: '/year_of_service',
          header: 'Year of Service',
          conditions: (IsSystemUser
            || IsLOBLeadUser
            || IsHRConfidentialUser
            || IsAdminUser
            || IsManagementUser
            || IsPMUser),
        },
        {
          no: 24,
          path: '/generation_report',
          header: 'Leave Generation Report',
          conditions: (IsSystemUser
            || IsLOBLeadUser
            || IsHRConfidentialUser
            || IsAdminUser
            || IsManagementUser
            || IsPMUser),
        },
        {
          no: 25,
          path: '/compensate_work_report',
          header: 'Compensate Work',
          conditions: (IsSystemUser
            || IsLOBLeadUser
            || IsHRConfidentialUser
            || IsAdminUser
            || IsManagementUser
            || IsPMUser),
        },
        {
          no: 26,
          path: '/subcontract_report',
          header: 'Subcontract Report',
          conditions: (IsAccountantUser || IsSystemUser),
        },
        {
          no: 31,
          path: pps_report.constants.PATH,
          header: pps_report.constants.HEADER,
          conditions:
            IsSystemUser
            || IsManagementUser
            || IsVPUser
            || IsPMUser
            || IsLOBLeadUser
            || IsAccountantUser
            || IsDisplayPPSUser,
        },
        {
          no: 32,
          path: billingplan_report.constants.PATH,
          header: billingplan_report.constants.HEADER,
          conditions:
            IsSystemUser
            || IsManagementUser
            || IsVPUser
            || IsPMUser
            || IsLOBLeadUser
            || IsAccountantUser
            || IsDisplayPPSUser,
        },
        {
          no: 33,
          path: summarytimesheet_report.constants.PATH,
          header: summarytimesheet_report.constants.HEADER,
          conditions:
            IsSystemUser
            || IsManagementUser
            || IsVPUser
            || IsPMUser
            || IsLOBLeadUser
            || IsAccountantUser
            || IsDisplayPPSUser,
        },
      ],
    }
    const favoriteMenu = this.state.favoriteMenu
    const iconUrl = this.state.iconUrl
    const favoriteList = this.getFavoriteList(favoriteMenu, menus)
    const windowWidth = window.innerWidth

    return (
      <SideDiv>
        <Nav vertical>
          <NavbarBrand>
            <Logo id="h-logo" src={ hlogo } alt="tel-logo" />
          </NavbarBrand>
        </Nav>
        <MenuDiv>
          <Nav vertical>
            <NormalsideBtn
              id='/home'
              onClick={ () => this.handleSidebar(0, '/home') }
              to={ { pathname: '/home', state: { header: 'My Dashboard' } } }
            >
              <TextSetNormal>Home</TextSetNormal>
              <div id="favourite-item" />
            </NormalsideBtn>
          </Nav>
          <Nav vertical>
            <NormalsideBtn
              id='/inbox'
              onClick={ () => this.handleSidebar(1, '/inbox') }
              to={ { pathname: '/inbox', state: { header: 'My Inbox' } } }
            >
              <TextSetNormal>Inbox</TextSetNormal>
            </NormalsideBtn>
          </Nav>
          {
            get(this.props, 'authData.user.favorite_menu.length') > 0 && windowWidth > 700 &&
            <Nav vertical>
              <HeadsideBtn onClick={ () => { this.toggleArrow(2) } } id="fv" >
                <TextSet>
                Favorites
                  <Icon src={ this.state.arrowUrl[2] } alt="tel-logo" />
                </TextSet>
              </HeadsideBtn>
              <Collapse isOpen={ this.state.collapse[2] }>
                {
                  favoriteList.map(item => {
                    return (
                      (item.conditions || item.conditions === null) &&
                      <Row key={ shortid() }>
                        <Condiv id={ item.path }>
                          <UserSideBtn
                            id={ item.path }
                            onClick={ () => this.handleSidebar(2, item.path) }
                            to={ { pathname: item.path, state: { header: item.header } } }
                          >
                            <TextLink>{ item.header }</TextLink>
                          </UserSideBtn>
                          <Star
                            src={ iconUrl[item.no] }
                            onClick={ () => this.toggleStar(item.no) }
                          />
                        </Condiv>
                      </Row>
                    )
                  })
                }
              </Collapse>
            </Nav>
          }
          <Nav vertical >
            <HeadsideBtn onClick={ () => { this.toggleArrow(3) } } id="fv" >
              <TextSet >
              Activities
                <Icon src={ this.state.arrowUrl[3] } alt="tel-logo" />
              </TextSet>
            </HeadsideBtn>
            <Collapse isOpen={ this.state.collapse[3] }>
              {
                menus.activities.map(item => {
                  return (
                    item.conditions && (windowWidth > 700 || item.onMobile) &&
                    <Row key={ shortid() }>
                      <Condiv id={ item.path }>
                        <UserSideBtn
                          id={ item.path }
                          onClick={ () => this.handleSidebar(3, item.path) }
                          to={ { pathname: item.path, state: { header: item.header } } }
                        >
                          <TextLink>{ item.header }</TextLink>
                        </UserSideBtn>
                        <Star
                          src={ iconUrl[item.no] }
                          onClick={ () => this.toggleStar(item.no) }
                        />
                      </Condiv>
                    </Row>
                  )
                })
              }
            </Collapse>
          </Nav>
          {
            adminConditions &&
            <AdminNav vertical >
              <HeadsideBtn onClick={ () => { this.toggleArrow(4) } } id="Ad">
                <TextSet>
                Admin
                  <Icon src={ this.state.arrowUrl[4] } alt="tel-logo" />
                </TextSet>
              </HeadsideBtn>
              <Collapse isOpen={ this.state.collapse[4] } style={ { marginTop: '5%' } }>
                {
                  menus.admin.map(item => {
                    return (
                      (item.conditions || item.conditions === null) &&
                      <Row key={ shortid() }>
                        <Condiv id={ item.path }>
                          <UserSideBtn
                            id={ item.path }
                            onClick={ () => this.handleSidebar(4, item.path) }
                            to={ { pathname: item.path, state: { header: item.header } } }
                          >
                            <TextLink>{ item.header }</TextLink>
                          </UserSideBtn>
                          <Star
                            src={ iconUrl[item.no] }
                            onClick={ () => this.toggleStar(item.no) }
                          />
                        </Condiv>
                      </Row>
                    )
                  })
                }
              </Collapse>
            </AdminNav>
          }
          {
            reportConditions &&
            <AdminNav vertical >
              <HeadsideBtn onClick={ () => { this.toggleArrow(5) } } id="sfsf" >
                <TextSet >Report<Icon src={ this.state.arrowUrl[5] } alt="tel-logo" /></TextSet>
              </HeadsideBtn>
              <Collapse isOpen={ this.state.collapse[5] }>
                {
                  menus.report.map(item => {
                    return (
                      (item.conditions || item.conditions === null) &&
                      <Row key={ shortid() }>
                        <Condiv id={ item.path }>
                          <UserSideBtn
                            id={ item.path }
                            onClick={ () => this.handleSidebar(5, item.path) }
                            to={ { pathname: item.path, state: { header: item.header } } }
                          >
                            <TextLink>{ item.header }</TextLink>
                          </UserSideBtn>
                          <Star
                            src={ iconUrl[item.no] }
                            onClick={ () => this.toggleStar(item.no) }
                          />
                        </Condiv>
                      </Row>
                    )
                  })
                }
              </Collapse>
            </AdminNav>
          }
          <Lastline />
        </MenuDiv>
      </SideDiv>

    )
  }
}

Sidebar.propTypes = {
  setCollapseSidebar: PropTypes.func.isRequired,
  editFavoriteMenu: PropTypes.func.isRequired,
}

const mapStateToProps = (state, props) => createStructuredSelector({
  employeeData: employeeSelector.getListUser,
  authData: authSelector.getAuth,
  favoriteMenu: employeeSelector.getFavoriteMenu,
  collapseSidebarData: sidebarSelector.getCollapseSidebarData,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  employeeList: employeeAction.getUser,
  getAuth: authAction.auth,
  editFavoriteMenu: employeeAction.editFavoriteMenu,
  resetEditFavoriteMenu: employeeAction.resetEditFavoriteMenu,
  setCollapseSidebar: sidebarAction.setCollapseSidebar,
  resetCollapseSidebar: sidebarAction.resetCollapseSidebar,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar)

const Icon = styled.img`
  width : 4%;
  height : 4%;
  float: right;
  margin-right: 5%;
  margin-top: 3%;
`
const Logo = styled.img`
  width : 60%;
  height : 60%;
  margin-left: 10%;
  margin-top: 5%;
`
const SideDiv = styled.div`
  background-color: #1A1A17;
  position: relative;
  height: 100%;
  width: 100%;
  // z-index: 9999 !important;
`
const UserSideBtn = styled(Link)`
  font-size: ${FONTS.SMALL_SIZE};
  color: white;
  border: none;
  cursor: pointer;
  height: 50px;
  width: 100%;
  padding-top: 5%;
  margin-left: 5%;
  text-align: left;
  &:hover {
    height: 50px;
    width: 100%;
    color:  #FFFFFF;
    text-decoration: none;
  }
`
const AdminNav = styled(Nav)`
  @media (max-width: 575.98px) {
    display:none;
  }
  @media (max-width: 767.98px) {
    display:none;
  }
  // @media (max-width: 900.98px) {
  //   display: none;
  // }
`
const TextSetNormal = styled.div`
  margin-left: 6%;
  margin-top: 5%;
  margin-bottom: 10%;
  font-family: ${FONTS.GOTHAM};
`
const Star = styled.img`
  align-self: center;
  width: 20px;
  height: 20px;
  margin-right: 15%;
  float: right;
  cursor: pointer;
`
const TextSet = styled.div`
  margin-left: 6%;
  margin-top: 20px;
  font-family: ${FONTS.GOTHAM};
`
const MenuDiv = styled.div`
  margin-top: 15%;
  background-color:  #1A1A17;
`
const HeadsideBtn = styled.div`
  background-color:  #1A1A17;
  font-size: ${FONTS.TITLE_SIZE};
  color: white;
  border-top: 0.1px solid #646F79;
  cursor: pointer;
  padding-bottom: 5%;
  text-align: left;
  &:hover {
    background-color: rgba(173, 38, 36, 0.2);
    border-top: 0.1px solid #646F79;
    color: white;
    cursor: pointer;
    text-align: left;
    padding-bottom: 5%;
  }
`
const Lastline = styled.div`
  border-top: 1px solid #646F79;
  cursor: pointer;
`
const NormalsideBtn = styled(Link)`
  background-color: ${props => {
    if (props.id.includes(window.location.pathname)) {
      return '#AD2624'
    }
    return '#1A1A17'
  }};
  font-size: ${FONTS.TITLE_SIZE};
  color: white;
  border: none;
  cursor: pointer;
  padding-top: -1%;
  padding-bottom: 7%;
  text-align: left;
  &:hover {
    background-color: ${props => {
    if (props.id.includes(window.location.pathname)) {
      return '#AD2624'
    }
    return 'rgba(173, 38, 36, 0.2)'
  }};
    color: white;
    border: none;
    cursor: pointer;
    padding-bottom: 7%;
    padding-top: -2%;
    text-align: left;
    text-decoration: none;
  }
`
const Condiv = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  background-color: ${props => {
    if (window.location.pathname.includes(props.id)) {
      return '#AD2624'
    }
    return '#1A1A17'
  }};
  &:hover {
    background-color: ${props => {
    if (window.location.pathname.includes(props.id)) {
      return '#AD2624'
    }
    return 'rgba(173, 38, 36, 0.2)'
  }};
  }
`
const TextLink = styled.p`
  margin-left: 5%;
  font-family: ${FONTS.GOTHAM} !important;
`




// WEBPACK FOOTER //
// ./src/components/sidebar/index.js